export default __webpack_public_path__ + "static/media/spinner.d13ffea4.gif";